<table class="table table-responsive" *ngIf="historicos; else carregando">
    <thead>
        <tr>
            <th style="width: 5%;"  >Data</th>
            <th style="width: 10%;">Estado</th>
            <th style="width: 10%;">Responsável</th>
        <tr>
    </thead>
    <tbody>
        <tr *ngFor="let hist of historicos">
            <td>{{ hist?.dataUltimaAtualizacao | date:'dd/MM/yyyy HH:mm'}}</td>
            <td>{{ hist?.estado?.nomeEstado }}</td>
            <td>{{ hist?.nomeUsuarioResponsavel}}</td>
        </tr>
    </tbody>
</table>


<ng-template #carregando>
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>